/**
 * Drop-off funnel — one horizontal step per question, bar width = % of
 * respondents who reached at least that question (server-computed from
 * `current_question_key`, see app/api/routes/b2b/quiz.py::compute_funnel).
 */
export default function QuizDropoffFunnel({ funnel, questions, total }) {
  const questionByKey = Object.fromEntries(questions.map((q) => [q.key, q]))

  return (
    <div className="bg-white rounded-3xl shadow-card p-6">
      <h3 className="text-xs font-bold uppercase tracking-wider text-ink-3">Drop-off funnel</h3>
      {total === 0 ? (
        <p className="mt-4 text-xs text-ink-3">Not enough data yet.</p>
      ) : (
        <div className="mt-4 space-y-3">
          {funnel.map((stage, index) => {
            const pct = Math.round((stage.reached / total) * 100)
            const label = questionByKey[stage.question_key]?.question ?? stage.question_key
            return (
              <div key={stage.question_key} className="space-y-1">
                <div className="flex items-center gap-2">
                  <span className="text-[10px] font-bold text-ink-3 w-5">{index + 1}</span>
                  <p className="text-xs font-medium text-ink-2 flex-1 truncate">{label}</p>
                  <span className="text-xs font-bold text-ink-3">{stage.reached}/{total}</span>
                </div>
                <div className="h-1.5 bg-canvas rounded-full overflow-hidden">
                  <div className="h-full rounded-full bg-accent" style={{ width: `${pct}%` }} />
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
